import RecordAccessControlRepository from '@/shared/http/repositories/business/recordAccessControl'

export default {
  name: 'RecordAccessControl',
  data () {
    return {
      accessControl: null
    }
  },
  methods: {
    ACCheckIn (entity, id) {
      if (id) {
        const obj = {
          id: '00000000-0000-0000-0000-000000000000',
          entidade: entity,
          entidadeID: id
        }
        return RecordAccessControlRepository.CheckIn(obj)
          .then(response => {
            if (response.data.code > 0) {
              this.accessControl = response.data.data
              this.ACPing()
              return {
                block: false
              }
            }
            return {
              block: true,
              name: response.data.data.nomeContaAcao
            }
          })
      } else {
        return new Promise((resolve) => {
          resolve({
            block: false
          })
        })
      }
    },
    ACCheckOut () {
      if (!this.accessControl) return

      RecordAccessControlRepository.CheckOut(this.accessControl.id)
        .then(response => {
          if (response.data.code > 0) {
            this.accessControl = null
          }
        })
    },
    ACPing () {
      setTimeout(() => {
        if (this.accessControl) {
          RecordAccessControlRepository.Ping(this.accessControl)
            .then(response => {
              this.ACPing()
            })
            .catch(ex => {
              console.log(ex)
              this.ACPing()
            })
        }
      }, 10000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins/recordAccessControl.js